/**
 * Shared settle semantics for Rolodex page-image signed URL lookups.
 *
 * Used to decide when PDF.js fallback is allowed without racing in-flight
 * 6400px / thumbnail fetches (POWER-117).
 */
export type PageImageRolodexSettleState = {
  isPending: boolean
  isFailed: boolean
}

export function resolveUuid5PageImageLookupUnavailable(args: {
  isSystemDocumentLoading: boolean
  bqDocumentId: string | undefined
}): boolean {
  return !args.isSystemDocumentLoading && args.bqDocumentId === undefined
}

export function resolvePageImageRolodexSettleState(args: {
  hasQuery: boolean
  url: string | undefined
  isLoading: boolean
  /**
   * True when a UUID5 page-image query will never be built (system document
   * loaded with no BQ document_id). Treat as a settled miss, not pending.
   */
  lookupUnavailable?: boolean
}): PageImageRolodexSettleState {
  const hasUrl = Boolean(args.url)
  const queryAttempted = args.hasQuery || Boolean(args.lookupUnavailable)
  const isPending = args.isLoading || (!queryAttempted && !hasUrl)
  const isFailed = !isPending && queryAttempted && !hasUrl
  return { isPending, isFailed }
}

/**
 * Only enable a PDF signed URL after the page-image Rolodex attempt failed.
 */
export function resolvePdfUrlForPageImageFallback(
  settle: PageImageRolodexSettleState,
  pdfUrl: string | undefined
): string | undefined {
  return settle.isFailed && pdfUrl ? pdfUrl : undefined
}
